export * from "-!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js??ref--6-2!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/lib/index.js??ref--6-3!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StatusPage.vue?vue&type=style&index=0&id=6fa285c4&prod&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/StatusPage.vue?vue&type=style&index=0&id=6fa285c4&prod&lang=css&
// module id = kf2S
// module chunks = 1